import { Cell } from '@table-library/react-table-library/table';
import UserDomains from '../UserDomains';
import { isTrue } from '../../helpers/isTrue';
import UserCancelationBtn from '../UserCancelation/OnlyButton';

export const COLUMNS = [
    {
        label: 'Name / Username',
        key: 'first_name',
        data: 'first_name',
        sortType: 'string',
        cellSize: 'minmax(150px, 1.5fr)',
        Component: Cell,
        renderCell: ({ item }) => {
            return (
                <strong className="d-flex align-items-center">
                    <label htmlFor={item.email}>
                        {item.first_name || item.username} {item.last_name}
                    </label>
                </strong>
            );
        },
    },
    {
        label: 'Email',
        key: 'email',
        data: 'email',
        sortType: 'string',
        Component: Cell,
        cellSize: 'minmax(120px, 1fr)',
    },
    {
        label: 'Domain',
        key: 'domain',
        data: 'domain',
        Component: Cell,
        cellSize: 'minmax(200px, 2fr)',
        renderCell: ({ item }) => {
            return <UserDomains user_id={item.id} domains={item.domains} />;
        },
    },
    {
        label: 'Date Joined',
        key: 'date_joined',
        data: 'date_joined',
        Component: Cell,
    },
    {
        label: 'Last Login',
        key: 'last_login',
        data: 'last_login',
        Component: Cell,
    },
    {
        label: 'User Type',
        key: 'user_type',
        data: 'user_type',
        sortType: 'string',
        Component: Cell,
    },
    {
        label: 'Licenses',
        key: 'licenses',
        data: 'licenses',
        Component: Cell,
        renderCell: ({ item }) => {
            return (
                <div>
                    <small>
                        {isTrue(item.user_license_license_deactivated) ||
                        item.user_type === 'Viewer' ? (
                            <span style={{ color: '#999' }}>-</span>
                        ) : (
                            <>
                                {item.user_license_plan_name}
                                <br />
                                {item.user_license_plan_period}
                                {!isTrue(item.user_cancel_at_period_end) && (
                                    <div>
                                        <a
                                            data-bs-toggle="modal"
                                            data-bs-target={`#modal-${item.id}`}
                                            type="button"
                                            className="btn deactivate-btn"
                                        >
                                            Deactivate
                                        </a>
                                    </div>
                                )}
                            </>
                        )}
                    </small>
                    <div
                        className="modal fade"
                        id={`modal-${item.id}`}
                        tabIndex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h6 className="modal-title" id="exampleModalLabel">
                                        Are you sure you want to deactivate the customer?
                                    </h6>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    ></button>
                                </div>
                                <div className="modal-footer">
                                    <UserCancelationBtn license_id={item.user_license_license_id} />
                                    <button
                                        type="button"
                                        className="btn btn-light"
                                        data-bs-dismiss="modal"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        },
    },
    {
        label: 'Subscription',
        key: 'subscription_status',
        data: 'subscription_status',
        Component: Cell,
        cellSize: 'minmax(100px, 0.8fr)',
        renderCell: ({ data, item }) => {
            if (data === 'None') return '-';

            return (
                <div>
                    {data}
                    <br />
                    {isTrue(item.cancel_at_period_end) && `Till ${item.cancel_in}`}
                </div>
            );
        },
    },
    {
        label: 'Log in',
        key: 'log_in',
        data: 'log_in',
        Component: Cell,
        cellSize: 'minmax(60px, 0.5fr)',
        renderCell: ({ item }) => {
            return (
                <a href={`/customers/login_as/${item.id}`}>
                    <i className="icofont-login"></i>
                </a>
            );
        },
    },
];
